export default __webpack_public_path__ + "static/media/pen-disabled.a79b8a8d.svg";